import type { GameMountContext, GameMountHandle } from "@universe/game-runner";
import { createElement } from "react";
import { createRoot, type Root } from "react-dom/client";
import { setLocale } from "./i18n";
import { WavemakerGame } from "./react/WavemakerGame";

export { meta } from "./meta";

export async function mount(
  root: HTMLElement,
  ctx: GameMountContext = {}
): Promise<GameMountHandle | void> {
  const locale = ctx.locale ?? "en";
  setLocale(locale);

  const html = document.documentElement;
  const body = document.body;
  const previousHtmlOverflow = html.style.overflow;
  const previousBodyOverflow = body.style.overflow;
  const previousRootOverflow = root.style.overflow;

  html.style.overflow = "visible";
  body.style.overflow = "visible";
  root.style.overflow = "visible";

  const container = document.createElement("div");
  container.style.width = "100%";
  container.style.height = "100%";
  container.style.overflow = "visible";
  root.appendChild(container);

  const reactRoot: Root = createRoot(container);
  reactRoot.render(createElement(WavemakerGame, { locale }));

  return {
    destroy: () => {
      reactRoot.unmount();
      if (container.parentElement === root) {
        root.removeChild(container);
      }
      html.style.overflow = previousHtmlOverflow;
      body.style.overflow = previousBodyOverflow;
      root.style.overflow = previousRootOverflow;
    },
  };
}
